<ul>
  <li *ngFor="let item of items" [class.selected]="item.selected" (click)="itemTapped(item)">
    <!-- <img [src]="item.product-image-url"> -->
    {{item.name}}
    <span>{{ item.age }}</span>
  </li>

</ul>

<span>list component</span>